export const ADD_OVERLAY = "ADD_OVERLAY"
export const REMOVE_OVERLAY = "REMOVE_OVERLAY"
export const CLOSE_OVERLAY = "CLOSE_OVERLAY"

export const addOverlay = (componentName, onOverlayClick) => ({
    type: ADD_OVERLAY,
    payload: {
        componentName,
        onOverlayClick
    }
})

export const removeOverlay = componentName => ({
    type: REMOVE_OVERLAY,
    payload: {
        componentName
    }
})

export const closeOverlay = () => ({
    type: CLOSE_OVERLAY,
    payload: {
        activeOverlays: []
    }
})